import {Action} from '@ngrx/store';
import {ChecklistItem} from '../../../models/checklist-item';
import {BijbEvent} from '../../../models/bijb-event';

export class AddChecklistItemAction implements Action {
  public static readonly type = 'AddChecklistItemAction';

  constructor(public bijbEvent: BijbEvent, public checklistItem: ChecklistItem) {
  }

  public type = AddChecklistItemAction.type;
}
